"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOptionsWithGroup = exports.isOptionWithGroup = void 0;
function isOptionWithGroup(data) {
    return data.group !== undefined;
}
exports.isOptionWithGroup = isOptionWithGroup;
function isOptionsWithGroup(data) {
    if (!data.length) {
        return false;
    }
    return isOptionWithGroup(data[0]);
}
exports.isOptionsWithGroup = isOptionsWithGroup;
//# sourceMappingURL=typeguards.js.map